<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica immagine gallery' : 'Nuovo gallery'"
                     @back="$router.replace('/gallery')" @saveback="save(true)" :loading="loading"></form-header>
        <v-col cols="12" lg="6">
          <v-text-field
              label="Nome*"
              v-model="editingItem.title"
              :rules="[rules.required]"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="py-0"></v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <media-field label="Icona" media-type="icon" :aspect-ratio="1" required v-model="editingItem.media_id"></media-field>
        </v-col>
        <v-col cols="12" lg="6">
          <media-field label="Immagine" media-type="gallery" :aspect-ratio="15/10" required v-model="editingItem.media_id"></media-field>
        </v-col>

        <v-col cols="12" class="py-0"></v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field type="number" step="1" label="Priorità" v-model="editingItem.priority" hint="quanto più alto è il valore prima si vede" persistent-hint></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch label="Pubblicato" v-model="editingItem.pub" ></v-switch>
        </v-col>

        <form-footer @back="$router.replace('/gallery')" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>
    </v-form>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import type { GalleryImage } from "@/models.ts";
import MediaField from "@/components/MediaField.vue";
import {DateTime} from "luxon";
export default {
  components: {MediaField, FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const loading = ref(false)

    const editingItem = ref<GalleryImage>({
      icon_id : "", media_id: "", priority: 0, pub: false, title: ""
    })

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<GalleryImage>('gallery', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/gallery')
        return
      }
      editingItem.value = res.data!
      loading.value = false;
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      await Promise.all([
          globals.refreshEmpty('media')
      ])
      if (route.params.id !== "new") {
        await loadData();
      }
    })




    return {
      form,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      rules,
      formatDate : utils.formatDate,
      async save(goBackAfterSave:boolean) {
        editingItem.value.priority  = utils.toInt(editingItem.value.priority, 0)

        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;

        const res = await api.save<GalleryImage>('gallery', editingItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        messages.success("nome salvato")
        if(goBackAfterSave) {
          await router.replace('/gallery')
        } else if(route.params.id === 'new'){
          await router.replace(`/gallery/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
